declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/**
 * Envía un evento personalizado a Google Analytics 4.
 * Seguro en SSR y cuando GA está bloqueado por el navegador.
 */
export function trackEvent(
  name: string,
  params: Record<string, string | number | boolean> = {},
): void {
  if (typeof window === "undefined") return;
  try {
    window.gtag?.("event", name, params);
    if (import.meta.env.DEV) {
      console.log("[analytics]", name, params);
    }
  } catch {
    /* no-op */
  }
}
